import { render, staticRenderFns } from "./CarriersTable.vue?vue&type=template&id=4a245990&scoped=true&"
import script from "./CarriersTable.vue?vue&type=script&lang=js&"
export * from "./CarriersTable.vue?vue&type=script&lang=js&"
import style0 from "./CarriersTable.vue?vue&type=style&index=0&id=4a245990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a245990",
  null
  
)

export default component.exports